"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiAvatarStyles = void 0;
var component_2023_design_tokens_1 = require("@rentspree/component-2023-design-tokens");
exports.muiAvatarStyles = {
    styleOverrides: {
        root: {
            backgroundColor: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.container.color'),
            height: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.container.height'),
            width: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.container.width'),
            color: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.color'),
            fontFamily: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.font'),
            fontWeight: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.weight'),
            fontSize: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.size'),
            letterSpacing: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.letter-spacing'),
            lineHeight: (0, component_2023_design_tokens_1.parseRSPToken)('rsp.comp.avatar.label-text.line-height'),
        },
    },
};
//# sourceMappingURL=avatar.js.map